import React, { useEffect, useState } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import plLocale from 'date-fns/locale/pl';
import { DateTextField } from '../../EditSession/TaskGroupDetails.styles';
import { format } from 'date-fns';

interface ICalendarProps {
  dateArg: Date;
  dateToParent: (date: Date | null) => void;
}

const CalendarPicker: React.FC<ICalendarProps> = ({ dateToParent }) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [isDateError, setIsDateError] = useState<boolean>(false);

  useEffect(() => {
    if (!selectedDate || isDateError) {
      setIsDateError(true);
      return;
    }
    try {
      if (selectedDate && Date.parse(selectedDate.toISOString())) {
        dateToParent(selectedDate);
      }
    } catch {
      //do nothing in case of error. Please don't refactor
    }
  }, [selectedDate]);

  const isValidDateFormat = (date: Date): boolean => {
    const formattedDate = format(date, 'dd/MM/yyyy');
    if (formattedDate.match(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[1,2])\/(19|20)\d{2}/)) {
      return true;
    } else return false;
  };

  const isInvalidDateRange = (value?: Date | null) => {
    if (value) {
      const dateNow = new Date();
      if (value.getTime() < dateNow.getTime() - 86400000) {
        return true;
      } else {
        return false;
      }
    } else return false;
  };

  const dateIsInvalid = (date: Date | null): boolean => {
    if (!date?.toString().length) return false;
    return !isValidDateFormat(date) || isInvalidDateRange(date);
  };

  const handleDateChange = (date: Date | null) => {
    if (date && !isNaN(date.getDate())) {
      setSelectedDate(date);
      setIsDateError(false);
    } else setIsDateError(true);
  };

  useEffect(() => {
    if (dateIsInvalid(selectedDate)) {
      setIsDateError(true);
    } else {
      setIsDateError(false);
    }
  }, [selectedDate]);

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={plLocale}>
        <DatePicker
          label="Data ważności konta"
          views={['year', 'month', 'day']}
          inputFormat="dd/MM/yyyy"
          onChange={handleDateChange}
          value={selectedDate}
          disablePast
          renderInput={(params) => (
            <DateTextField
              margin="normal"
              {...params}
              fullWidth
              error={isDateError}
              helperText={isDateError && 'Nieprawidłowa data'}
            />
          )}
        />
      </LocalizationProvider>
    </>
  );
};

export default CalendarPicker;
